export default "__VITE_ASSET__DPAAmj2T__"